import environment from "src/utils/environment";
import downloadFile from "src/utils/downloadFile";

const path = window.require("path");
const fs = window.require("fs");
const { app } = window.require("@electron/remote");
const log = window.require("electron-log");
const { isBrowser } = environment;

class LocalFiles {
  constructor({ directoryName, srcResolver }) {
    this.srcResolver = srcResolver;
    this.directoryName = directoryName;
    this.shouldCheckDirectoryExistence = true;
  }

  getDirectoryPath() {
    if (isBrowser) return undefined;
    const userDataPath = app.getPath("userData");
    const location = path.join(userDataPath, this.directoryName);
    if (
      this.shouldCheckDirectoryExistence &&
      fs.existsSync(location) === false
    ) {
      fs.mkdirSync(location);
      this.shouldCheckDirectoryExistence = false;
    }
    return location;
  }

  getPath(filename) {
    if (isBrowser) return undefined;
    return path.join(this.getDirectoryPath(), filename);
  }
  getSrc(filename) {
    if (isBrowser) return undefined;
    return "file://" + this.getPath(filename);
  }

  getFilenames() {
    if (isBrowser) return undefined;
    const filenames = fs.readdirSync(this.getDirectoryPath());
    return filenames.filter((filename) => filename.startsWith(".") === false);
  }

  exists(filename) {
    if (isBrowser) return undefined;
    return fs.existsSync(this.getPath(filename));
  }

  write(filename, data, opts) {
    if (isBrowser) return undefined;
    const destination = this.getPath(filename);

    return new Promise((resolve, reject) => {
      fs.writeFile(destination, data, opts, (error) =>
        error ? reject(error) : resolve()
      );
    });
  }

  delete(filename) {
    if (isBrowser) return;
    fs.unlink(this.getPath(filename), (error) => {
      if (error) {
        log.error(error);
      }
    });
  }

  async deleteAll() {
    if (isBrowser) return;
    await Promise.all(
      this.getFilenames().map((name) =>
        fs.promises.unlink(this.getPath({ name }))
      )
    );
  }

  download(file) {
    if (isBrowser) return undefined;
    const destination = this.getPath(file.name);
    return downloadFile(file.url, destination);
  }
}

class NoFilesInBrowser {
  constructor({ srcResolver }) {
    this.srcResolver = srcResolver;
    return new Proxy(this, {
      get(obj, prop) {
        if (prop === "srcResolver") return srcResolver;
        return () => undefined;
      }
    });
  }
}

export default isBrowser ? NoFilesInBrowser : LocalFiles;
